import styled from "styled-components";

export const DividerWithText = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    margin: 24px 0;

    .line {
        width: 100%;
        border-top: 1px solid #00aaff;
        margin: 20px 0;
    }

    .text {
        color: #00aaff;
        font-weight: 600;
        font-size: 14px;
        text-align: center;
        padding: 4px 12px;
        background: white;
        border-radius: 4px;
    }

`;
export const StateFormContainer = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 0px 112px;
`;

export const StateFormItemWrapper = styled.div`
  width: 416px;
  margin-bottom: 10px;
`;

export const FullWidthWrapper = styled.div`
  width: 100%;
  margin-bottom: 50px;
  padding: 0px 112px; /* matches the form padding */
`;

export const NewSiteFooterButtonWrapper = styled.div`
  display: flex;
  gap: 16px;
  // justify-content:right;
  // margin-top:17px;
  z-index:1003;
  width:200px;
  padding: 8px;
  

  > button {
    margin: 0;
  }
`

export const TabsWrapper = styled.div`
  display: flex;
  gap: 16px;
  border-bottom: 1px solid rgba(32, 32, 32, 0.1);
 ${({ showBorder }) =>
    showBorder &&
    `
      border-bottom: 1px solid rgba(32, 32, 32, 0.1);
    `}
`;

export const ValidationDiv = styled.div`
  position: absolute;
  top: 35%;
  right: -5%;
`